"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
const entity_2 = __importDefault(require("../file/entity"));
let FilesForCustomerEntity = class FilesForCustomerEntity extends entity_2.default {
};
__decorate([
    (0, entity_1.field)({ type: 'int' })
], FilesForCustomerEntity.prototype, "customer_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], FilesForCustomerEntity.prototype, "job_description", void 0);
FilesForCustomerEntity = __decorate([
    entity_1.EntityDecorator
], FilesForCustomerEntity);
exports.default = FilesForCustomerEntity;
//# sourceMappingURL=../../../../src/models/filesForCustomer/entity.js.map